// extracted by mini-css-extract-plugin
export default {"Button":"Dialog_Button__lIgae","disabled":"Dialog_disabled__34pkw","ButtonLink":"Dialog_ButtonLink__XQhjs"};